import React from "react";
import { Handshake, TrendingUp, Map, BadgeCheck } from "lucide-react";
import { useSEO } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageBits";
import LeadForm from "@/components/LeadForm";

const BENEFITS = [
  { icon: TrendingUp, t: "Attractive Margins", d: "Distributor pricing designed for healthy profitability." },
  { icon: Map, t: "Exclusive Territories", d: "Protected regions for committed partners." },
  { icon: BadgeCheck, t: "Marketing Support", d: "Branding, samples and sales collateral." },
  { icon: Handshake, t: "Reliable Supply", d: "Consistent stock and on-time fulfilment." },
];

export default function Distributor() {
  useSEO({ title: "Become a Distributor", description: "Partner with Leaf Alchemy as a distributor. Attractive margins, exclusive territories and reliable supply of premium tea powder across India." });

  return (
    <div data-testid="distributor-page">
      <PageHero eyebrow="Partnership" title="Become a Leaf Alchemy Distributor"
        image="https://images.unsplash.com/photo-1491497895121-1334fc14d8c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
        subtitle="Grow your business with a premium tea brand. Join our network of distributors across India." />

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16">
          <div>
            <Reveal>
              <h2 className="font-display text-3xl text-forest">Why Partner With Us</h2>
              <p className="text-muted-foreground mt-4">Leaf Alchemy is building India&rsquo;s most trusted premium tea powder brand — and we want strong regional partners to grow with us.</p>
              <div className="grid sm:grid-cols-2 gap-6 mt-10">
                {BENEFITS.map((b) => (
                  <div key={b.t} className="bg-cream border border-forest/10 rounded-2xl p-6 hover:border-gold/40 transition-colors">
                    <b.icon className="text-forest mb-3" size={26} />
                    <h4 className="font-display text-lg text-forest">{b.t}</h4>
                    <p className="text-sm text-muted-foreground mt-1">{b.d}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <div className="bg-forest text-cream rounded-2xl p-7 shadow-xl lg:sticky lg:top-28" data-testid="distributor-form-card">
              <h3 className="font-display text-2xl text-gold mb-1">Distributor Enquiry</h3>
              <p className="text-sm text-cream/70 mb-5">Fill in your details and our partnerships team will reach out.</p>
              <div className="bg-cream rounded-xl p-5">
                <LeadForm type="distributor" fields={["name", "phone", "email", "company", "city", "message"]} submitLabel="Apply Now" />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
